import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { ExploreServiceState } from '../redux/exploreServiceSlice';

export const useIsSeasonalSort = () => {
  const exploreServiceSort = useSelector((state: { exploreService: ExploreServiceState }) => state.exploreService.sort);

  const isSeasonalSort = useMemo(() => {
    return exploreServiceSort === 'seasonal' || (exploreServiceSort && exploreServiceSort.startsWith('month_'));
  }, [exploreServiceSort]);

  return isSeasonalSort;
};
